import React from 'react';
import { ContainerLayout } from 'components/ContainerLayout/ContainerLayout';
import { BloodPressureDetailsView } from 'components/BloodPressureDetails/BloodPressureDetailsView';
import { useNavigate } from 'features/cobrand/hooks/useCobrandUtils';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { useBloodPressureDetails } from 'features/progress/hooks/useBloodPressureDetails';

export const BloodPressureDetails = () => {
  const navigate = useNavigate();
  const user = useLoggedInUser();
  const { download, ...details } = useBloodPressureDetails(user?.id);

  return (
    <ContainerLayout>
      <BloodPressureDetailsView
        {...details}
        onBack={() => navigate('/progress')}
        onDownload={download}
      />
    </ContainerLayout>
  );
};
